import React, { memo, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import useDebounce from "react-use/lib/useDebounce";

import type { ChangeEvent, JSX } from "react";

const SEARCH_DEBOUNCE_MS = 250;

interface SelectBoxSearchProps {
  onChangeSearch: (search: string) => void;
  searchText?: string;
}

function SelectBoxSearch({
  onChangeSearch,
  searchText,
}: SelectBoxSearchProps): JSX.Element {
  const { t } = useTranslation("editor-content");
  const [value, setValue] = useState(searchText ?? "");

  useEffect(() => {
    setValue(searchText ?? "");
  }, [searchText]);

  useDebounce(() => onChangeSearch(value), SEARCH_DEBOUNCE_MS, [value]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setValue(event.target.value);
  };

  return (
    <div className="editor-select-box-search form-group">
      <div className="input-group">
        <div className="input-group-addon">
          <i className="material-icons">search</i>
        </div>
        <input
          className="search-input"
          id="selected-search"
          onChange={handleChange}
          placeholder={t("searchPlaceholder")}
          type="text"
          value={value}
        />
      </div>
    </div>
  );
}

export default memo(SelectBoxSearch);
